module.exports = __webpack_public_path__ + "img/check.3d9c39bc.svg";